import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  FiChevronDown,
  FiLogOut,
  FiMenu,
  FiSettings,
  FiUser,
  FiX
} from "react-icons/fi";

import { getProfile, } from "../../store/slices/profile";
import { logout } from "../../store/slices/auth";

export default function Header({
  onMenuClick,
  isCollapsed,
  onToggleCollapse
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [profileOpen, setProfileOpen] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  /* ================= GET PROFILE FROM REDUX ================= */

  const {
    profile,
    user,
    loading
  } = useSelector((state) => state.auth);

  /* ================= CALL GET PROFILE ================= */

  useEffect(() => {
    dispatch(getProfile());
  }, [dispatch]);


  const profileData =
    profile?.data ||
    profile ||
    user?.data ||
    user ||
    {};

  const name = profileData?.name || "User";
  const email = profileData?.email || "";

  // Generate initials for avatar
  const initials = name
    .split(" ")
    .map((word) => word.charAt(0))
    .join("")
    .slice(0, 2)
    .toUpperCase();

  /* ================= LOGOUT ================= */

  const handleLogout = () => {
    setProfileOpen(false);
    setShowLogoutModal(true);
  };

  const confirmLogout = async () => {
    await dispatch(logout());

    // Extra safety
    localStorage.clear();
    sessionStorage.clear();

    setShowLogoutModal(false);

    navigate("/", {
      replace: true
    });
  };

  const cancelLogout = () => {
    setShowLogoutModal(false);
  };

  return (
    <>
      <header className="gi-header">
        <div className="gi-header-inner">

          {/* ================= LEFT ================= */}

          <div className="gi-header-left">

            <button
              type="button"
              className="gi-mobile-menu"
              onClick={onMenuClick}
              aria-label="Open navigation"
            >
              <FiMenu />
            </button>

            <Link
              to="/dashboard"
              className="gi-header-brand"
            >
              <span className="gi-header-brand-name">
                Global Inavation
              </span>
            </Link>

          </div>

          {/* ================= RIGHT ================= */}

          <div className="gi-header-actions">

            <div className="gi-profile-wrap">

              <button
                type="button"
                className="gi-profile-trigger"
                onClick={() =>
                  setProfileOpen((v) => !v)
                }
              >

                {/* Avatar */}

                <span className="gi-profile-avatar">
                  {initials}
                </span>

                {/* Name + Email */}

                <span className="gi-profile-copy">

                  <strong>
                    {loading
                      ? "Loading..."
                      : name}
                  </strong>

                  <small>
                    {email}
                  </small>

                </span>

                <FiChevronDown
                  className={
                    profileOpen
                      ? "gi-chevron-open"
                      : ""
                  }
                />

              </button>

              {/* ================= PROFILE MENU ================= */}

              {profileOpen && (

                <div className="gi-profile-menu">



                  <button
                    type="button"
                    onClick={handleLogout}
                  >
                    <FiLogOut />
                    Logout
                  </button>

                </div>

              )}

            </div>

            <button
              type="button"
              className="gi-mobile-close"
              onClick={onMenuClick}
              aria-label="Close navigation"
            >
              <FiX />
            </button>

          </div>

        </div>
      </header>


      {/* ================= LOGOUT MODAL ================= */}

      {showLogoutModal &&
        createPortal(

          <div
            className="gi-logout-overlay"
            onClick={cancelLogout}
          >

            <div
              className="gi-logout-modal"
              onClick={(e) =>
                e.stopPropagation()
              }
            >

              <button
                type="button"
                className="gi-logout-close"
                onClick={cancelLogout}
                aria-label="Close"
              >
                <FiX />
              </button>

              <div className="gi-logout-icon">
                <FiLogOut />
              </div>

              <h3>Sign out?</h3>

              <p>
                Are you sure you want to sign out of
                your account?
              </p>

              <div className="gi-logout-actions">

                <button
                  type="button"
                  className="gi-logout-cancel"
                  onClick={cancelLogout}
                >
                  Cancel
                </button>

                <button
                  type="button"
                  className="gi-logout-confirm"
                  onClick={confirmLogout}
                >
                  <FiLogOut />
                  Sign out
                </button>

              </div>

            </div>

          </div>,

          document.body
        )}

    </>
  );
}